module.exports = __webpack_public_path__ + "pc/img/body_basic-12.f7b2d1e0.png";